import React, { useState } from "react";
import { useAuth } from "./AuthContext";

type Mode = "login" | "signup";

const AuthPage: React.FC = () => {
  const { login, signup } = useAuth();
  const [mode, setMode] = useState<Mode>("login");
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [password1, setPassword1] = useState("");
  const [password2, setPassword2] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setBusy(true);
    try {
      if (mode === "login") {
        await login(username, password1);
      } else {
        if (password1 !== password2) throw new Error("Passwords do not match");
        await signup(username, email, password1, password2);
      }
    } catch (err) {
      setError(err instanceof Error ? err.message : "Something went wrong");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="auth-wrap">
      <div className="auth-card">
        <div className="brand">
          <span className="brand-mark">𝍅</span>
          <h1>Frigatebird</h1>
        </div>
        <p className="tagline">Learn to code with 2025 MLB pitch-tracking data.</p>

        <div className="tabs">
          <button
            className={mode === "login" ? "tab active" : "tab"}
            onClick={() => { setMode("login"); setError(null); }}
            type="button"
          >
            Log in
          </button>
          <button
            className={mode === "signup" ? "tab active" : "tab"}
            onClick={() => { setMode("signup"); setError(null); }}
            type="button"
          >
            Sign up
          </button>
        </div>

        <form onSubmit={submit}>
          <label>
            Username
            <input value={username} onChange={(e) => setUsername(e.target.value)} autoComplete="username" required />
          </label>
          {mode === "signup" && (
            <label>
              Email
              <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} autoComplete="email" required />
            </label>
          )}
          <label>
            Password
            <input
              type="password"
              value={password1}
              onChange={(e) => setPassword1(e.target.value)}
              autoComplete={mode === "login" ? "current-password" : "new-password"}
              required
            />
          </label>
          {mode === "signup" && (
            <label>
              Confirm password
              <input
                type="password"
                value={password2}
                onChange={(e) => setPassword2(e.target.value)}
                autoComplete="new-password"
                required
              />
            </label>
          )}

          {error && <div className="error">{error}</div>}

          <button className="primary" type="submit" disabled={busy}>
            {busy ? "..." : mode === "login" ? "Log in" : "Create account"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AuthPage;
